export enum SaveEditActions {
  SAVE = 'SAVE',
  EDIT = 'EDIT',
  UPDATE = 'UPDATE',
}
